// inbox/enumLabels.js — 5A-plus (البند 3) · مصدر واحد لترجمة كل قيم
// التعداد الإنجليزية الخام القادمة من الباك-إند إلى عربي. أي قيمة غير
// معروفة تُعاد كما هي (الرجوع الآمن)، فحص التسريب يغطي القيم المعروفة فقط.
export const SENTIMENT_LABELS = {
  positive: "إيجابي",
  negative: "سلبي",
  neutral: "محايد",
};

export const CHANNEL_LABELS = {
  whatsapp: "واتساب",
  instagram: "إنستغرام",
  facebook: "فيسبوك",
  messenger: "ماسنجر",
  twitter: "X (تويتر)",
  tiktok: "تيك توك",
  snapchat: "سناب",
  // تدقيق تالٍ (طلب مستقل) — رسالة وصلت عبر جسر Make.com القديم لا
  // الويب هوك المباشر من ميتا (source != meta_native): لا تُنتحَل قناة
  // Instagram/فيسبوك غير مؤكَّدة الأصل.
  make: "جسر Make.com",
};

export const NAME_SOURCE_LABELS = {
  customer: "من سجل العميل",
  whatsapp: "اسم واتساب",
  phone: "رقم الهاتف",
};

export const INTERACTION_STATUS_LABELS = {
  open: "مفتوحة",
  closed: "مغلقة",
  cancelled: "ملغاة",
};

export function arLabel(dict, key, fallback) {
  if (!key) return fallback ?? "";
  return dict[key] || fallback || key;
}
